"use client";

import { motion, useAnimation } from "framer-motion";
import { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
const DEFAULT_TRANSITION = {
  type: "spring",
  stiffness: 250,
  damping: 25
};
const Maximize2Icon = forwardRef(({
  onMouseEnter,
  onMouseLeave,
  className,
  size = 28,
  ...props
}, ref) => {
  const controls = useAnimation();
  const isControlledRef = useRef(false);
  useImperativeHandle(ref, () => {
    isControlledRef.current = true;
    return {
      startAnimation: () => controls.start("animate"),
      stopAnimation: () => controls.start("normal")
    };
  });
  const handleMouseEnter = useCallback(e => {
    if (isControlledRef.current) {
      onMouseEnter?.(e);
    } else {
      controls.start("animate");
    }
  }, [controls, onMouseEnter]);
  const handleMouseLeave = useCallback(e => {
    if (isControlledRef.current) {
      onMouseLeave?.(e);
    } else {
      controls.start("normal");
    }
  }, [controls, onMouseLeave]);
  return <div className="contents" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} {...props}>
        <svg className={className} fill="none" height={size} stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">
          <motion.path animate={controls} d="M3 16.2V21m0 0h4.8M3 21l6-6" transition={DEFAULT_TRANSITION} variants={{
        normal: {
          translateX: "0%",
          translateY: "0%"
        },
        animate: {
          translateX: "-2px",
          translateY: "2px"
        }
      }} />
          <motion.path animate={controls} d="M21 7.8V3m0 0h-4.8M21 3l-6 6" transition={DEFAULT_TRANSITION} variants={{
        normal: {
          translateX: "0%",
          translateY: "0%"
        },
        animate: {
          translateX: "2px",
          translateY: "-2px"
        }
      }} />
        </svg>
      </div>;
});
Maximize2Icon.displayName = " Maximize2Icon";
export { Maximize2Icon };
